const translation = {
  common: {
    submit: 'Concluir',
    back: 'Voltar',
    ok: 'OK',
    save: 'Salvar',
    cancel: 'Cancelar',
    send: 'Enviar',
    next: 'Próximo',
    advance: 'Avançar',
    yes: 'Sim',
    notApplicable: 'Não aplicável',
    patient: 'Paciente',
    inProgress: 'em andamento',
    hospitalLogoAlt: 'Logo do hospital',
  },
  validation: {
    required: 'Campo obrigatório',
    cpfInvalid: 'CPF inválido',
    selectAtLeastOneItem: 'É necessário selecionar ao menos um item!',
    mustSelectOneItem: 'Você precisa selecionar ao menos um item!',
    integerQuantityOnly: 'Só é possível solicitar quantidades inteiras!',
    quantityLessThan: 'A quantidade precisa ser menor do que {{max}}.',
    quantityGreaterThan: 'A quantidade precisa ser maior do que {{min}}.',
    quantityBetween: 'A quantidade precisa estar entre {{min}} e {{max}}.',
  },
  language: {
    selector: {
      open: 'Selecionar idioma',
    },
    modal: {
      title: 'Seletor de idioma',
      subtitle: 'Selecione o idioma de sua preferência.',
      save: 'Salvar',
    },
  },
  welcome: {
    title: 'Seja bem-vindo(a)!',
    body: 'Para que comece a utilizar o app, precisamos que confirme se você é o <strong>paciente</strong> ou <strong>acompanhante</strong>.',
    bodyExtra:
      'Utilizamos esta informação para garantir que você tenha a melhor experiência!',
    userType: {
      patient: 'Sou paciente',
      companion: 'Sou acompanhante',
    },
  },
  login: {
    pageTitle: 'Confirme sua identidade',
    illustrationAlt:
      'Ilustração com profissionais da saúde prontos para atender',
    almostThere: 'Quase lá...',
    companionInstructions:
      'Para acessar o sistema, por favor, insira abaixo o seu nome e o <strong>número de atendimento</strong> localizado na pulseira de identificação da pessoa que está sendo acompanhada, ou o <strong>código de acesso</strong> localizado abaixo do QR Code, conforme instrução da equipe do hospital.',
    patientInstructions:
      'Para acessar o sistema, por favor, insira abaixo o seu <strong>número de atendimento</strong>, localizado na pulseira de identificação, ou o <strong>código de acesso</strong> localizado abaixo do QR Code, conforme instrução da equipe do hospital.',
    fields: {
      name: 'Seu nome',
      admission: 'Número do atendimento',
      companionBirthDate: 'Qual é a data de nascimento do paciente?',
      patientBirthDate: 'Qual é a sua data de nascimento?',
    },
  },
  home: {
    pageTitle: 'Início - Quality24',
    heading: 'Como podemos ajudar?',
    cards: {
      nurse: 'Chamar enfermagem',
      infrastructure: 'Solicitar {{service}}',
      feedbackFallback: 'Manifestações espontâneas',
    },
  },
  greeting: {
    morning: 'Bom dia',
    afternoon: 'Boa tarde',
    evening: 'Boa noite',
  },
  nav: {
    home: 'Início',
    orders: 'Meus Chamados',
  },
  errors: {
    loadAdmission:
      'Não foi possível carregar sua internação. Por favor, verifique seus dados e conexão com a internet.',
    requestFailed:
      'Não foi possível fazer sua requisição. Por favor, tente novamente.',
    surveyRequestFailed:
      'Não foi possível fazer sua requisição. Por favor tente novamente.',
    coverageCheckFailed:
      'Não foi possível verificar a cobertura do seu atendimento. Tente novamente.',
    cancelOrderFailed:
      'Falha ao cancelar o chamado. Tente novamente. Se o erro persistir, entre em contato com o suporte.',
    genericRequest: 'Houve um erro na solicitação. Por favor, tente novamente.',
    serviceUnavailableAtThisTime:
      'Esta categoria de serviço não está disponível para este horário.',
  },
  payment: {
    status: {
      awaitingPayment: 'Ag. Pagamento',
      paid: 'Pago',
      denied: 'Negado',
      expired: 'Expirado',
      voided: 'Anulado',
      notCompleted: 'Não Finalizado',
      authorized: 'Autorizado',
      refund: 'Devolução',
    },
  },
  pain: {
    none: 'Sem dor',
    mild: 'Leve',
    moderate: 'Moderada',
    severe: 'Severa',
    verySevere: 'Muito severa',
    worst: 'Pior dor possível',
  },
  rating: {
    terrible: 'Péssimo',
    bad: 'Ruim',
    regular: 'Regular',
    good: 'Bom',
    great: 'Ótimo',
  },
  maintenance: {
    title: 'Este serviço está em manutenção.',
    body: 'Por favor, aguarde para utilizá-lo.',
  },
  survey: {
    improvements: {
      question: 'Na sua opinião, quais dos itens abaixo podem ser melhorados?',
      subtitle: 'Selecione quantos achar necessário.',
    },
    nav: {
      progress: 'Progresso da pesquisa',
    },
    notification: {
      text: 'Que tal nos contar <strong>como foi a sua experiência</strong> nest{{connector}} {{day}}?',
      cta: 'clique para responder',
    },
    comment: {
      label: 'Deixe seu comentário abaixo:',
    },
    success: 'Muito obrigado! Sua avaliação foi recebida com sucesso.',
  },
  dailySurvey: {
    pageTitle: 'Avaliação Diária - Quality24',
    confirmFinishTitle:
      'Você tem certeza que deseja finalizar e enviar esta avaliação?',
    noAnswersTitle: 'Você não respondeu nenhuma pergunta!',
    cancelEvaluation: 'Cancelar avaliação',
    reviewQuestions: 'Rever perguntas',
    confirmFinishBody:
      'Se desejar rever ou alterar alguma resposta clique em "Cancelar". Caso contrário, clique em "Enviar".',
    noAnswersBody: 'Gostaria de cancelar esta avaliação ou rever as perguntas?',
    respondNow: 'Responder agora',
    respondLater: 'Responder mais tarde',
    declineToAnswer: 'Não quero responder',
  },
  callEvaluation: {
    evaluate: 'Avaliar',
    title: 'Avalie seu chamado',
    message:
      'Qual nota você daria para sua experiência durante a resolução deste chamado?',
    comment: 'Comentário',
    skip: 'Não quero avaliar',
  },
  alerts: {
    noActive: 'Não há chamados ativos',
    noResolved: 'Não existem chamados resolvidos',
    viewDetails: 'Ver Detalhes',
    resolvedAt: 'Resolvido às {{time}}',
    responsible: 'Responsável: {{name}}',
    cancelledToast:
      'Seu chamado de "{{reason}}" foi cancelado com o motivo "{{cancelReason}}".',
    notInformed: 'Não informado',
  },
  order: {
    category: {
      nursing: 'enfermagem',
    },
    section: {
      request: 'Solicitar {{category}}',
      selectOptionToOpen: 'Selecione uma opção abaixo para abrir o chamado',
    },
    createRequest: 'Criar Solicitação',
    selectOption: 'Selecione uma opção',
    openCall: 'Abrir chamado',
    fillBelow: 'Preencha abaixo',
    selectReason: 'Selecione um dos motivos abaixo:',
    details: {
      pageTitle: 'Detalhes da Solicitação - Quality24',
      /** Joins a localized date and time — `L` and `LTS` in moment */
      dateAtTime: '{{date}} às {{time}}',
      date: 'Data',
      placed: 'Pedido Realizado',
      paymentApproved: 'Pagamento Aprovado',
      inProgress: 'Em Andamento',
      cancelled: 'Cancelado',
      closed: 'Encerrado',
      order: 'Pedido',
      items: 'Itens do Pedido',
      total: 'Total',
      totalValue: 'Valor Total',
      cancelOrder: 'Cancelar Pedido',
      payNow: 'Pagar Agora',
    },
    tracking: {
      pageTitle: 'Solicitações - Quality24',
      open: 'Abertos ({{count}})',
      finished: 'Finalizados ({{count}})',
    },
    rating: {
      pageTitle: 'Avaliação do Chamado - Quality24',
      messageWithResolver:
        "Como você avalia sua experiência na resolução do chamado para '{{reason}}', resolvido por {{resolver}}?",
      message:
        "Como você avalia sua experiência na resolução do chamado para '{{reason}}'?",
    },
  },
  hospitalInfo: {
    additionalInfo: 'Informações Adicionais',
    learnMore: 'Saber mais',
    pageTitle: 'Informações Gerais - Quality24',
  },
  customData: {
    generalInfo: 'Informações Gerais',
    otherServices: 'Outros Serviços',
  },
  integration: {
    notFound: 'O atendimento informado não foi encontrado.',
    loading: 'Aguarde enquanto carregamos seu atendimento...',
  },
  lgpd: {
    consentSuccess:
      'Você concordou com os termos de proteção de dados. Seja bem-vindo(a)!',
    agree: 'Concordar',
    refuse: 'Recusar',
    refuseAndLogout: 'Recusar e deslogar',
    confirmRefuse:
      'Você tem certeza? Ao recusar os termos, você será deslogado do aplicativo.',
  },
} as const;

export default translation;
